import React, { useState, useEffect } from "react";
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
} from "@mui/material";
import useForm from "src/hooks/useForm";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

import { mapFormControlsToObject } from "src/utils/amUtils";
import { toast } from "react-toastify";
import { getCaption } from "src/utils/dictionary";

function AMFilter({
  controls,
  onApply,
  autoApplyFilter,
  expanded,
  applyTitle,
  title,
  toolTip,
  initialCriteria,
  withoutAccordionSummary,
}) {
  // const [criteria, setCriteria] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    state: subFormState,
    errors: subFormErrors,
    renderFormInput,
    formControls,
    renderErrorsSection,
    vaLidateFormData: validateSubFormData,
    handleSetFullState: setSubFormFullState,
  } = useForm({
    isSubForm: true,
    subFormControls: mapFormControlsToObject(controls),
  });

  useEffect(() => {
    setSubFormFullState({ ...initialCriteria });
  }, [initialCriteria]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      isSubmitting ||
      (subFormErrors && Object.keys(subFormErrors).length > 0)
    ) {
      return;
    }
    setIsSubmitting(true);
    if (validateSubFormData()) {
      try {
        if (subFormErrors && Object.keys(subFormErrors).length > 0) {
          setIsSubmitting(false);
          return;
        }
        console.log(subFormState);
        onApply(subFormState);
      } catch (error) {
        toast.error(error.message);
      }
    }
    setIsSubmitting(false);
  };

  return (
    <Accordion
      defaultExpanded
      sx={{
        borderRadius: "5px",
        marginBottom: "10px",
      }}
    >
      {withoutAccordionSummary || (
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon sx={{ color: "#FFF", fontSize: "36px" }} />
          }
          sx={{
            backgroundColor: "secondary.dark",
            color: "#FFF",
            borderRadius: "5px",
            marginTop: "10px",
            height: "48px",
            minHeight: "48px !important",
          }}
        >
          {/* <Typography variant="h5">
          Filter Section : {"  "}
          <Typography variant="caption">
            Filter Data by the following criteria
          </Typography>
        </Typography> */}
          <Typography variant="h5">
            {title}
            <Typography variant="caption">
              {".: "}
              {toolTip}
            </Typography>
          </Typography>
        </AccordionSummary>
      )}
      <AccordionDetails
        sx={{
          marginTop: "20px",
        }}
      >
        {renderErrorsSection()}
        <Grid container spacing={4}>
          {!!controls &&
            !!controls.length &&
            controls.map((control) => {
              if (control.fieldName && control.controlType) {
                return renderFormInput(
                  control.fieldName,
                  control.controlType.toLowerCase(),
                  null,
                  {
                    lg: 4,
                    xl: 4,
                    md: 6,
                    sm: 6,
                    xs: 12,
                    style: { paddingBottom: 5, paddingTop: 5 },
                  }
                );
              }
            })}
        </Grid>

        <Grid
          item
          lg={12}
          xl={12}
          md={12}
          sm={12}
          xs={12}
          style={{ textAlign: "center" }}
        >
          <Button
            onClick={handleSubmit}
            variant="contained"
            color="primary"
            disabled={Object.keys(subFormErrors).length > 0 || isSubmitting}
          >
            {applyTitle || getCaption("view_report")}
          </Button>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default AMFilter;
